import type { Language } from './types';

export interface PluralForms<T extends string = string> {
  one: T;
  few: T;
  many: T;
}

export function pluralize<T extends string>(n: number, forms: PluralForms<T>, language: Language): T {
  const absN = Math.abs(n);

  if (language === 'uz' || language === 'fa' || language === 'tr') {
    return forms.many;
  }

  if (language === 'en' || language === 'pt' || language === 'de' || language === 'es') {
    return absN === 1 ? forms.one : forms.many;
  }

  const mod10 = absN % 10;
  const mod100 = absN % 100;

  // WHY: в польском «one» только у 1 — 21, 31 и 101 уже «many», в отличие от русского и украинского
  if (language === 'pl') {
    if (absN === 1) return forms.one;
    return mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14) ? forms.few : forms.many;
  }

  if (mod10 === 1 && mod100 !== 11) {
    return forms.one;
  }

  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
    return forms.few;
  }

  return forms.many;
}
